/* global am4core bocAmchart4 */
/* exported am4themes_boc */

/**
 * Master color array to define series colors
 * @type {string[]}
 */
/*  eslint-disable line-comment-position */
bocAmchart4.bocColors = [
    "#67b7dc", "#fdd400", "#0eb663", "#b92020", // 0  - 3
    "#f6871e", "#a92c90", "#f089b8", "#8f7456", // 4  - 7
    "#e5c273", "#ee3344", "#0069eb", "#cb7eff", // 8  - 11
    "#006090", "#f8b79c", "#20a0a0", "#375c15", // 12 - 15
    "#b0d050", "#ff5166", "#86346a", "#897cb0", // 16 - 19
    "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", // 20 - 23
    "#6f7800", "#40db47", "#4434a5", "#ffb64e", // 24 - 27
    "#059103", "#ff62dd", "#000000", "#c21d61", // 28 - 31
    "#cc6402", "#8f5468", "#194fff", "#5e88f2", // 32 - 35
    "#cd6884", "#c1876b", "#08809c", "#cc0bb2", // 36 - 39
    "#588836", "#9a0cff", "#d1361c", "#a38440", // 40 - 43
    "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", // 44 - 47
    "#5e8892", "#3266ad", "#a07dff", "#ffffff"  // 48 - 51
];
/*  eslint-enable line-comment-position */

/**
 * Dark theme copy of color array to define series colors
 * @type {string[]}
 */
bocAmchart4.bocDarkColors = bocAmchart4.bocColors.slice();
// Swap the black and white for dark mode
bocAmchart4.bocDarkColors[30] = bocAmchart4.bocColors[51];
bocAmchart4.bocDarkColors[51] = bocAmchart4.bocColors[30];

/**
 * Dark theme boc function
 * @param {object} target Object to be adjusted
 * @returns {void}
 */
bocAmchart4.bocDarkTheme = function (target) {
    if (target instanceof am4core.ColorSet) {
        target.list = bocAmchart4.bocDarkColors.map(function (hexColor) {
            return am4core.color(hexColor);
        });
    }

    /** possible values for setFor
         "stroke"
         "fill"
         "primaryButton"
         "primaryButtonHover"
         "primaryButtonDown"
         "primaryButtonActive"
         "primaryButtonText"
         "primaryButtonStroke"
         "secondaryButton"
         "secondaryButtonHover"
         "secondaryButtonDown"
         "secondaryButtonActive"
         "secondaryButtonText"
         "secondaryButtonStroke"
         "grid"
         "background"
         "alternativeBackground"
         "text"
         "alternativeText"
         "disabledBackground"
         "positive"
         "negative"
     */
    if (target instanceof am4core.InterfaceColorSet) {
        // Used for most text by default
        target.setFor("text", am4core.color("#e6e6e6"));
        // Used for background of scrollbar selected area
        target.setFor("fill", am4core.color("#333333"));
        // Used for axis tooltip bg
        target.setFor("alternativeBackground", am4core.color("#232323"));
        // used for unselected graph scrollbar and tooltip background
        target.setFor("background", am4core.color("#151522"));
        // colors used for scrollbar handles in different states
        target.setFor("secondaryButton", am4core.color("#555555"));
        target.setFor("secondaryButtonHover", am4core.color("#666666"));
        target.setFor("secondaryButtonDown", am4core.color("#565656"));
        // This one is used for outline of the handles but also selected area
        target.setFor("secondaryButtonStroke", am4core.color("#787878"));
        // Color used for grid lines with some transparency applied to it
        target.setFor("grid", am4core.color("#ffffff"));
        // Used for grip lines and axis tooltip text
        target.setFor("alternativeText", am4core.color("#aaaaaa"));
        bocAmchart4.colorSet = target;
    }
};

/**
 * Theme boc function
 * @param {object} target Object to be adjusted
 * @returns {void}
 */
bocAmchart4.bocTheme = function (target) {
    if (target instanceof am4core.ColorSet) {
        //add light theme colors here
        target.list = bocAmchart4.bocColors.map(function (hexColor) {
            return am4core.color(hexColor);
        });
    }
    if (target instanceof am4core.InterfaceColorSet) {
        target.setFor("text", am4core.color("#38395a"));
        // Used for button fill
        target.setFor("secondaryButton", am4core.color("#cccccc"));
        target.setFor("secondaryButtonHover", am4core.color("#bbbbbb"));
        target.setFor("secondaryButtonDown", am4core.color("#aaaaaa"));

        // Used for grip lines
        target.setFor("alternativeText", am4core.color("#eeeeee"));
        bocAmchart4.colorSet = target;
    }
};

/**
 *
 * @param {string} theme that is handed to the function
 * @returns {undefined}
 */
bocAmchart4.setTheme = function (theme) {
    if (theme === "boc") {
        am4core.useTheme(bocAmchart4.bocTheme);
    } else if (theme === "bocDark") {
        am4core.useTheme(bocAmchart4.bocDarkTheme);
    }
};
